import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  DialogActions,
  TextField,
  Typography,
  // Box,
  Button,
} from "@material-ui/core";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { LinehaulFloatingDataContext } from "../../Contexts/LinehaulFloatingDataContext";
// import ButtonApprove from "../ButtonApprove";
// import { makeStyles } from "@material-ui/core/styles";
// import clsx from "clsx";
import ButtonDownload from "../ButtonDownload";
import { getWeekDates } from "../../GlobalFunctions";
const axios = require("axios");

// const useStyles = makeStyles((theme) => ({
//   flexColContainer: {
//     display: "flex",
//     flexDirection: "column",
//   },
//   flexColItem: {
//     marginBottom: theme.spacing(1),
//   },
//   flexRowContainer: {
//     display: "flex",
//   },
//   flexRowItem: {
//     flexGrow: 1,
//     width: "100%",
//     // whiteSpace: "nowrap",
//     overflow: "hidden",
//     textOverflow: "ellipsis",
//   },
// }));

const ApproveLinehaul = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { createFloatingModel } = useContext(LinehaulFloatingDataContext);

  const floatingModel = createFloatingModel({ week });
  const [assignedBranchId, setAssignedBranchId] = useState("");
  const [loading, setLoading] = useState(false);

  const { userData, setUserData } = useContext(UserDataContext);

  // const classes = useStyles();

  const handleChange = async (event) => {
    setAssignedBranchId(event.target.value);
  };

  const editFloating = async (newVal) => {
    // const newData = { ...itemData, assignedBranchId: Number(newVal) };

    // const requestChange = {
    //   method: "POST",
    //   url: `floating/change/`,
    //   headers: {
    //     "Content-Type": "application/json",
    //     Authorization: `bearer ${userData.token}`,
    //   },
    //   data: newData,
    // };
    const requestApprove = {
      method: "POST",
      url: `floating/approve/${itemId}/${newVal}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    const { startDate, endDate } = getWeekDates(week);
    const requestStatus = {
      method: "GET",
      url: `/invoices/getState/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}/${week}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };
    try {
      setLoading(true);
      // await axios(requestChange);
      await axios(requestApprove);

      const res = await axios(requestStatus);
      let invoiceStatuses = userData.invoiceStatuses;
      invoiceStatuses[truckId][week] = res.data.invoiceState;
      setUserData({ ...userData, invoiceStatuses });
      // await dispatch({
      //   type: "UPDATE_ITEM",
      //   truckId,
      //   week,
      //   day,
      //   itemData: newData,
      //   roleId: userData.roleId,
      //   itemId,
      // });
      // await dispatch({
      //   type: "APPROVE_ITEM",
      //   truckId,
      //   week,
      //   day,
      //   itemId,
      //   itemData,
      // });

      setLoading(false);
      props.onClose();
    } catch {}
  };

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Approval Screen</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={1}
        >
          {[
            "km",
            "tripRate",
            "originBranchId",
            "destinationBranchId",
            "tripCost",
            "adminComments",
            "driverComments",
          ].map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>{floatingModel[col].displayName}:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={itemData[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    {...floatingModel[col].textFieldProps}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}

          <Grid item>
            <Grid container>
              <Grid item xs={3}>
                <Typography>
                  {floatingModel.assignedBranchId.displayName}:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={assignedBranchId}
                  // value={floatingModel.assignedBranchId.displayValue(assignedBranchId)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={
                    !floatingModel.assignedBranchId.validate(assignedBranchId)
                  }
                  onChange={handleChange}
                  {...floatingModel.assignedBranchId.textFieldProps}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item>
            <Grid container>
              <Grid item xs={3}>
                <Typography>Fuel Adjustment Factor:</Typography>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  fullWidth
                  value={Math.round(Number(itemData.totalCost) * 0.068 * 100) / 100}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonDownload variant="contained" color="primary" itemId={itemId} />
        <Button
          disabled={loading || assignedBranchId === ""}
          onClick={() => editFloating(assignedBranchId)}
          variant="contained"
          color="primary"
        >
          Approve
        </Button>
        {/* <ButtonApprove
          disabled={loading}
          callback={props.onClose}
          variant="contained"
          color="primary"
          controller="floating"
          truckId={truckId}
          week={week}
          day={day}
          itemId={itemId}
          itemData={itemData}
        /> */}
      </DialogActions>
    </Dialog>
  );
};

export default ApproveLinehaul;

ApproveLinehaul.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
  itemData: PropTypes.object.isRequired,
};
